import {css} from '@emotion/react'
import {getLinkData} from './qrCodeHelpers'

const QrLink = () => {
    const qrCodeData = getLinkData()
    const QrCodeComponent = qrCodeData.qrCode

    return (
        <div
            css={css`
                border-radius: 11.55px;
                background: #fff;
                padding: 8px;
                line-height: 0;
            `}
        >
            <QrCodeComponent
                css={css`
                    width: 62px;
                    height: auto;
                `}
            />
        </div>
    )
}

export default QrLink
